import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from '../common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';

import { changeNum } from '../common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function LogEnergy() {
    let dark = useSelector((state) => { return state.Darkmode.value });
    let log_id = useSelector((state) => { return state.log_id.value });

    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "")
    const [select, setSelect] = useState(false)
    const [selectValue, setSelectValue] = useState("ID")
    const [page, setPage] = useState(1)
    const [totalpage, setTotalPage] = useState(1)

    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    const statusRef = useRef(null)

    const [data, setData] = useState([])
    const [dataList, setDataList] = useState([])
    const [statusSelect, setStatusSelect] = useState(false)
    const [statusPosition, setStatusPosition] = useState("")

    const [checked, setChecked] = useState(true)
    const [checked1, setChecked1] = useState(true)
    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSubmitSearch()
        }
    };
    
    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""))
        }, 100)
    }, [])

    useEffect(() => {
        UpgradeData()
    }, [page, reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/log/energy', {
            params: {
                page: page,
                pageSize: 20,
                userId: search
            }
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setData(tmp?.data?.log ?? [])
                setPage(tmp?.data?.pagination.currentPage ?? 0)
                setTotalPage(tmp?.data?.pagination?.totalRecords ?? 0)
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    useEffect(() => {
        if (data && data.length > 0) {
            let filter = [];
            let filter1 = [];

            if (selectValue === "ID" && search.length > 0) {
                filter = data.filter((p) => {
                    if (p.user_id) return p.user_id.toString().includes(search);
                });
            } else {
                filter = data;
            }

            filter.map(function (a, i) {
                if (checked & a.his_type == '0') filter1.push(a)
                if (checked1 & a.his_type == '1') filter1.push(a)
            })

            setDataList(filter1);
        }
    }, [data, checked, checked1])

    const handleCheckCoordinates = () => {
        if (statusRef.current) {
            const rect = statusRef.current.getBoundingClientRect();

            setStatusPosition({ "top": rect.top + 24, "left": Math.max(580, rect.left - 10) })
        }
    };

    let filterData = dataList

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                {
                    statusSelect
                        ? <>
                            <div className='modal' onClick={(e) => { e.stopPropagation(); setStatusSelect(false) }}></div>
                            <div className={`member-status-select-box ${darkname}`} style={{ top: statusPosition.top, left: statusPosition.left }}>
                                <div className='member-status-box'>
                                    <span>누적</span>
                                    <span className={checked ? 'regist-box-left-form-3-span1 checked' : 'regist-box-left-form-3-span1'} onClick={() => setChecked(checked => !checked)}></span>
                                </div>
                                <div className='member-status-box'>
                                    <span>소비</span>
                                    <span className={checked1 ? 'regist-box-left-form-3-span1 checked' : 'regist-box-left-form-3-span1'} onClick={() => setChecked1(checked => !checked)}></span>
                                </div>
                            </div>
                        </>
                        :
                        ""
                }
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect(e => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {
                                select
                                    ?
                                    <FontAwesomeIcon icon={faSortUp} />
                                    :
                                    <FontAwesomeIcon icon={faSortDown} />
                            }
                            {
                                select
                                    ? <>
                                        <div className='modal' onClick={() => setSelect(true)}></div>
                                        <div className={`member-1-select-box ${darkname}`}>
                                            <div onClick={() => { setSelectValue(`ID`); setSelect(true) }}>ID</div>
                                        </div>
                                    </>
                                    :
                                    ""
                            }
                        </div>
                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input value={search} onChange={onChangeSearch} placeholder='Search' onKeyDown={handleKeyPress} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {
                                search.length > 0
                                    ?
                                    <FontAwesomeIcon icon={faCircleXmark} className='member-1-search-ico-2' onClick={() => setSearch("")} />
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    <div className={`search-btn ${darkname}`} onClick={() => onSubmitSearch()}>Search</div>
                </div>
                <div className={`member-2 ${darkname}`} style={{ width: "1100px" }}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "10%", minWidth: "100px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>로그 날짜</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>유저 아이디</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>로그 유형</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>변동량</div>
                        <div style={{ width: "10%", minWidth: "130px" }}>최종 수량</div>
                        <div style={{ width: "10%", minWidth: "250px" }}>부연설명</div>
                        <div>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                filterData.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            filterData.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} />
                                                )
                                            })
                                        }
                                        <NewPage initialData={totalpage} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>

                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark }) {

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.id}</div>
                <div className='td' style={{ width: "10%", minWidth: "150px" }}>{item.his_date}</div>
                <div className='right td' style={{ width: "10%", minWidth: "120px" }}>{item.user_id}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.his_type === "0" ? '누적' : item.his_type === "1" ? "소비" : ""}</div>
                <div className='right td' style={{ width: "10%", minWidth: "100px" }}>{changeNum(item.his_amount)}</div>
                <div className='right td' style={{ width: "10%", minWidth: "130px" }}>{changeNum(item.his_balance)}</div>
                <div className='left td' style={{ width: "10%", minWidth: "250px" }}>{item.his_desc}</div>
                <div className='td'>-</div>
            </div>
        </>
    )
}

export default LogEnergy;